const getPureGameId = (gameId: string) => {
  const fromUniq = gameId
    .split('__')
    .find(item => item.startsWith('id:'))
    ?.replace('id:', '')
  if (fromUniq) return fromUniq
  const fromId = /(?:^|[_:])id:(.+)$/.exec(gameId)?.[1]
  return fromId || gameId
}

export const HALLOWEEN_CATEGORY = 'Halloween' as const

export const halloweenGames: string[] = [
  'vs10bhallbnza3',
  'HauntedReels',
  'CluckingHell',
  'SlotMachine_BookOfSpinOWeen',
  'endorphina2_100Zombies@ENDORPHINA',
  '988',
  'SlotMachine_HalloweenCharms',
  'vs10bhallbnza2',
  'HalloweenBonanza',
  'Retro_BookOfWitchcraft',
  'SlotMachine_SpookyHalloween',
  'WitchOfFortune1000',
  'MonsterHunt',
  'vs10bhallbnza',
  'BoneBonanza',
  '10520',
  'SlotMachine_HallowReels',
  'SGVampiresFate',
  '878',
  '986',
  'SGHotHotHalloween',
  'mr-hallow-win',
  '2075272',
  'Tower_1ReelHalloween-CW',
  'immortalromance_mg_html',
  '435262',
  'vs20frankie',
  'VoodooPeople',
  'wanted_dead_or_a_wild',
  'SlotMachine_HolidaysJoker-Halloween',
  'vampires-charm',
  'blood_suckers_2',
  'vs40voodoo',
  'endorphina2_TheVampires2@ENDORPHINA',
  'lost_relics',
  'SpinAndSpell',
  '1635221',
  'FaceOff',
  'CandyMonsta',
  'LuckyDamaMuerta',
  'blood_suckers_touch',
  'S-HV01',
]

const HALLOWEEN_ID_ALIASES: Record<string, string> = {
  '10469': '435262',
  CoinsofHalloweenHoldAndWin: '988',
  RagstoWitches: '878',
  ZombieMashHoldandWin: '986',
}

export const getHalloweenMatchId = (gameId: string): string => {
  const pure = getPureGameId(gameId)
  const colonIdx = pure.lastIndexOf(':')
  const stripped = colonIdx === -1 ? pure : pure.slice(colonIdx + 1)
  return HALLOWEEN_ID_ALIASES[stripped] || stripped
}

export const isHalloweenGameId = (gameId: string): boolean => {
  const matchId = getHalloweenMatchId(gameId)
  return halloweenGames.some(raw => {
    const rawMatch = getHalloweenMatchId(raw)
    return (
      gameId === raw ||
      matchId === raw ||
      matchId === rawMatch ||
      gameId.endsWith(`id:${raw}`) ||
      gameId.endsWith(`:${rawMatch}`)
    )
  })
}

export function getHalloweenTab(...gameIds: string[]): string[] {
  return gameIds.some(id => Boolean(id) && isHalloweenGameId(id)) ? [HALLOWEEN_CATEGORY] : []
}
